import requests from '../../../request'

const ContentTypeEnum = {
    JSON: 'application/json;charset=UTF-8',
}

/**
 * 批次变动明细列表
 */
export function queryDetailList(data) {
    return requests(
        {
            url: '/stock/lot/detail/list',
            data,
            method: 'post',
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}

/**
 * 修改批次（生产日期、保质期天数）
 */
export function modifyLot(data) {
    return requests(
        {
            url: '/stock/lot/modify',
            data,
            method: 'post',
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}
